// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "ChatRegressionAgreementBucket" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";

export const ChatRegressionAgreementBucketGenShape = z.strictObject({
  floor: z.number(),
  ceil: z.number(),
  comparisonCount: z.number(),
  agreementCount: z.number(),
  agreementRate: z.number(),
  overturnedCount: z.number(),
  overturnRate: z.number(),
});
